/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Diff_Type_DeletedInputs */

const en_compare_event_groups_diff_type_deleted = /** @type {(inputs: Compare_Event_Groups_Diff_Type_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deleted`)
};

const fr_compare_event_groups_diff_type_deleted = /** @type {(inputs: Compare_Event_Groups_Diff_Type_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`supprimé`)
};

const de_compare_event_groups_diff_type_deleted = /** @type {(inputs: Compare_Event_Groups_Diff_Type_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gelöscht`)
};

const it_compare_event_groups_diff_type_deleted = /** @type {(inputs: Compare_Event_Groups_Diff_Type_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cancellato`)
};

const ru_compare_event_groups_diff_type_deleted = /** @type {(inputs: Compare_Event_Groups_Diff_Type_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`удалено`)
};

const es_compare_event_groups_diff_type_deleted = /** @type {(inputs: Compare_Event_Groups_Diff_Type_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eliminado`)
};

const zh_cn2_compare_event_groups_diff_type_deleted = /** @type {(inputs: Compare_Event_Groups_Diff_Type_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已删除`)
};

const ja_compare_event_groups_diff_type_deleted = /** @type {(inputs: Compare_Event_Groups_Diff_Type_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除済み`)
};

const hi_compare_event_groups_diff_type_deleted = /** @type {(inputs: Compare_Event_Groups_Diff_Type_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हटाए गए`)
};

const pt_pt2_compare_event_groups_diff_type_deleted = /** @type {(inputs: Compare_Event_Groups_Diff_Type_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deletado`)
};

/**
* | output |
* | --- |
* | "deleted" |
*
* @param {Compare_Event_Groups_Diff_Type_DeletedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_diff_type_deleted = /** @type {((inputs?: Compare_Event_Groups_Diff_Type_DeletedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Diff_Type_DeletedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_diff_type_deleted(inputs)
	if (locale === "de") return de_compare_event_groups_diff_type_deleted(inputs)
	if (locale === "it") return it_compare_event_groups_diff_type_deleted(inputs)
	if (locale === "ru") return ru_compare_event_groups_diff_type_deleted(inputs)
	if (locale === "es") return es_compare_event_groups_diff_type_deleted(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_diff_type_deleted(inputs)
	if (locale === "ja") return ja_compare_event_groups_diff_type_deleted(inputs)
	if (locale === "hi") return hi_compare_event_groups_diff_type_deleted(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_diff_type_deleted(inputs)
	return en_compare_event_groups_diff_type_deleted(inputs)
});